export interface EthosValue {
  title: string
  description: string
}

export const ethosValues: EthosValue[] = [
  {
    title: 'Proven Leadership',
    description:
      'Learn from people who have already produced the results you’re chasing. Our leadership is built on real experience—not theory.',
  },
  {
    title: 'Open-Door Support',
    description:
      'You’re never far from the guidance you need. Leadership, coaching, and answers are accessible when it matters most.',
  },
  {
    title: 'One Team',
    description:
      'We compete together, grow together, and win together. Everyone contributes, everyone supports, and no one builds alone.',
  },
  {
    title: 'Do What’s Right',
    description:
      'Character matters. We operate with honesty, professionalism, and a commitment to doing things the right way—regardless of who’s watching.',
  },
  {
    title: 'Own the Outcome',
    description:
      'We take responsibility for our results. We keep our commitments, measure performance, and hold ourselves and each other to a higher standard.',
  },
]
